import { FlexGrowCol, FlexRow, useAsyncEffect } from '@xylabs/sdk-react'
import { useState } from 'react'

import { AuctionCard, Family } from '../../Components'
import { useGeotoken } from '../../Contexts'
import { PropertyArea } from './Details'
import GeotokenNotExistDialog from './GeotokenNotExistDialog'

const InnerPage: React.FC = () => {
  const geotoken = useGeotoken()
  const [exists, setExists] = useState<boolean>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (mounted) => {
      if (geotoken) {
        const exists = await geotoken.fetchExists()
        if (mounted()) {
          setExists(exists)
        }
      }
    },
    [geotoken],
  )

  return (
    <FlexGrowCol justifyContent="flex-start" alignItems="stretch" flexWrap="wrap" marginY={1}>
      <FlexRow flexWrap="wrap" justifyContent="flex-start" alignItems="stretch">
        <AuctionCard quadkey={geotoken?.quadkey} size="medium" margin={1} />
        <Family hideTitles hideValue hideQuadkey margin={1} spacing={1} quadkey={geotoken?.quadkey} size="xsmall" />
      </FlexRow>
      <PropertyArea />
      <GeotokenNotExistDialog open={exists === false} />
    </FlexGrowCol>
  )
}

export default InnerPage
